// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-title[data-v-73d0b27c]{margin-bottom:1rem;font-size:1.125rem;line-height:1.75rem;font-weight:600;text-transform:uppercase;line-height:1;--tw-text-opacity:1;color:rgba(14,40,63,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = exports;
